import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";

import i18next from "./i18next";
import { I18nextProvider } from "react-i18next";
import { SnackbarProvider } from 'notistack';
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { debMediaTheme } from "./theme";

import { ProjectTypeProvider } from "./components/ProjectTypeProvider";
import AuthProvider from "./components/AuthProvider";
import CustomRouter from "./components/CustomRouter";

i18next.init({
    interpolation: {escapeValue: false},
});

function App() {

    const theme = createTheme(debMediaTheme);
    window.theme = theme;

    return (
        <div className="app">
            <I18nextProvider i18n={i18next}>
                <ThemeProvider theme={theme}>
                        <SnackbarProvider
                            maxSnack={3}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}>
                            <ProjectTypeProvider>
                                <AuthProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <CssBaseline />
                                        <CustomRouter />
                                    </LocalizationProvider>
                                </AuthProvider>
                            </ProjectTypeProvider>
                        </SnackbarProvider>
                </ThemeProvider>
            </I18nextProvider>
        </div>
    );
}

export default App;
